
let selectedItem = null;

const blogAuthors = [
    { name: 'ANURADHA SINGH' },
    { name: 'Namrata Pawar' },
    { name: 'Peter Merholz' },
    { name: 'Ryan deiss' },
    { name: 'Maria Jones' },
    { name: 'Vishal Khandelwal' }
]

const categoryFilters = [
    {
        id:1,
        name: "Country 1",
        states: [
            {
                id:1,
                name: "Country1 State1",
                cities: [
                    {id:1,name:"city 1"},
                    {id:2,name:"city 2"}
                ]
            },
            {
                id:2,
                name: "Country1 State2",
                cities: [
                    {id:3,name:"city 1"},
                    {id:4,name:"city 2"}
                ]
            }
        ]
    },
    {
        id:2,
        name: "Country 2",
        states: [
            {
                id:3,
                name: "Country2 State1",
                cities: [
                    {id:5,name:"city 1"},
                    {id:6,name:"city 2"}
                ]
            },
            {
                id:4,
                name: "Country2 State2",
                cities: [
                    {id:7,name:"city 1"},
                    {id:8,name:"city 2"}
                ]
            }
        ]
    },
]

function inputChange(parentId) {
    const foundMatch = [];
    const input = document.querySelector(`#${parentId} input`);
    document.querySelector(`#${parentId} .searchDropDown`).classList.remove('fadeItem');
    blogAuthors.forEach(el => { el.name.toLowerCase().includes(input.value.toLowerCase()) && foundMatch.push(el) });
    showResults(foundMatch, parentId)
}

function toggleDropDown(parentId) {
    const element = document.querySelector(`#${parentId} .searchDropDown`);
    console.log("here");
    console.log(element);
    if (element.classList.contains('fadeItem')) {
        element.classList.remove('fadeItem');
    }
    else {
        element.classList.add('fadeItem');
    }
}

function selectItem(item, parentId, type) {
    const input = document.querySelector(`#${parentId} input`);
    input.value = item.name;

    toggleDropDown(parentId);
    if (type === 'country') {
        addStateFilters(item)
    }
}

function showResults(array, parentId, type = null) {
    const searchItemsHolder = document.querySelector(`#${parentId} .dropDownHolder`);
    removeAllChildNodes(searchItemsHolder);
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            const div = document.createElement('div');
            div.classList.add('dropItem');
            div.innerText = element.name;
            div.addEventListener('click', () => selectItem(element, parentId, type));
            searchItemsHolder.appendChild(div);
        }
    }
    else {
        searchItemsHolder.innerHTML = `                    
        <div id="noItemFound" class="text-center text-muted" style="padding: 0.5rem;">
            No result found
        </div>
    `
    }

}

function removeAllChildNodes(parent) {
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
}

function mapDataToCategory(parentId) {
    document.querySelector(`#${parentId} .searchDropDown`).classList.remove('fadeItem')

    const input = document.querySelector(`#${parentId} input`)

    showResults([...categoryFilters.filter(el => el.name.toLowerCase().includes(input.value.toLowerCase())).map((el => { return el }))], parentId, 'country');
}

function addStateFilters(item) {
    console.log(item);
    const accordionParent = document.getElementById("accordionExample");

    for (let i = 0; i < item.states?.length; i++) {
        const state = item.states[i];
        const accordionItem = document.createElement('div');
        accordionItem.classList.add("accordion-item");
        accordionItem.classList.add("border-0");
        accordionItem.innerHTML =
            `
        <h2 class="accordion-header" id="heading${state.name}">
            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapse${state.id}">
                <input id="check${state.id}" type="checkbox" class="mainCheckBox" />
                <label for="check${state.id}" class="fw-bold text-black">
                    ${state.name}
                </label>
            </button>
        </h2>
        `
        accordionParent.appendChild(accordionItem);

        for (let j = 0; j < state.cities?.length; j++) {
            const city = state.cities[j];

            const accordionItemChild = document.createElement('div');
            accordionItemChild.classList.add('accordion-collapse');
            accordionItemChild.classList.add('collapse');
            accordionItemChild.id = `collapse${state.id}`;
            accordionItemChild.setAttribute('data-bs-parent',"#accordionExample");
            accordionItemChild.innerHTML =
                `
            <div class="accordion-body">
                <div class="subFilterItem">
                    <input id="checkbox${city.id}"  type="checkbox" class="cityCheckBox" />
                    <label for="checkbox${city.id}"  class="cityLabel">
                        ${city.name}
                    </label>
                </div>
            </div>
            `
            accordionItem.appendChild(accordionItemChild);
        }

    }
}

// NEED TO PUT 'data-type='video' in slide

const items = document.getElementsByClassName('carousel');

for (let i = 0; i < items.length; i++) {
    const carousel = items[i];
    const normalDuration = (carousel.getAttribute('data-transition-time') * 1000) || 6000;
    const carouselInner = document.querySelector(`#${carousel.id} .carousel-inner`);
    const childNodes = carouselInner.childNodes;
    for (let j = 0; j < childNodes.length; j++) {
        const child = childNodes[j];
        if (child.classList?.contains('slide') && child.getAttribute('data-type') === 'video') {
            const video = document.querySelector(`.slide video`);
            child.setAttribute('data-bs-interval', video.duration * 1000);
        }
        else{
            if (typeof child === 'object' && child !== null && 'setAttribute' in child) {
                child.setAttribute('data-bs-interval', normalDuration);
            }
        }
    } 
    }



